import { MessageDto } from '@core/mappers/user/pushNotifications/dtos/MessageDto';
import { BalanceDto } from '@core/mappers/user/pushNotifications/dtos/BalanceDto';
import { PaymentDto } from '@core/mappers/user/pushNotifications/dtos/PaymentDto';
import Message from '@core/models/user/pushNotifications/Message';
import Balance from '@core/models/user/pushNotifications/Balance';
import Payment from '@core/models/user/pushNotifications/Payment';

export enum PushEventType {
    Message = 'message',
    Balance = 'balance',
    Payment = 'payment',
    BonusUpdate = 'bonus_update',
}

export type PushEventData = BalanceDto | PaymentDto | MessageDto;

export type MappedData = Balance | Payment | Message;

export type ServerMessageMapper = {
    [PushEventType.Message]: (data: MessageDto) => Message;
    [PushEventType.Balance]: (data: BalanceDto) => Balance;
    [PushEventType.Payment]: (data: PaymentDto) => Payment;
};

export interface PushEvent {
    type: PushEventType;
    data: PushEventData;
}
